/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDmUnreadCountResponse
 */
export interface GetDmUnreadCountResponse {
    /**
     * Total unread DM count across all conversations
     * @type {number}
     * @memberof GetDmUnreadCountResponse
     */
    count: number;
}

/**
 * Check if a given object implements the GetDmUnreadCountResponse interface.
 */
export function instanceOfGetDmUnreadCountResponse(value: object): value is GetDmUnreadCountResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function GetDmUnreadCountResponseFromJSON(json: any): GetDmUnreadCountResponse {
    return GetDmUnreadCountResponseFromJSONTyped(json, false);
}

export function GetDmUnreadCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDmUnreadCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function GetDmUnreadCountResponseToJSON(json: any): GetDmUnreadCountResponse {
    return GetDmUnreadCountResponseToJSONTyped(json, false);
}

export function GetDmUnreadCountResponseToJSONTyped(value?: GetDmUnreadCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

